import React, { useState } from "react";
import './formstyle.css';
import Navbar from '../../components/Navbar';
import axios from "axios";
import url from "../../function/url";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
function CompanyRegistration () {
  const [companyname,setCompanyname] = useState("");
    const [mobile,setMobile] = useState("");
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [cpassword,setCPassword] = useState("");
    const [address,setAddress] = useState("");
    const [image, setImage] = useState(null);
    const navigate = useNavigate();
    const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer;
              toast.onmouseleave = Swal.resumeTimer;
            },
          });
    const handleSubmit = (e) =>{
      e.preventDefault();
      const formdata = new FormData();
      formdata.append('company',companyname);
      formdata.append('mobile',mobile);
      formdata.append('Email',email);
      formdata.append('password',password);
      formdata.append('address',address);
      if (image) {
        formdata.append('image',image);
      }
      axios
      .post(`${url.path}/company_reg/`, formdata)
      .then((res) => {
        if (res.data.status){
          Cookies.set("log_id",res.data.log_id);
          navigate("/company_details");
        }
        
      })
      .catch((err) => {
        Toast.fire({
          icon:'error',
          title:err
        })
      });
    };
    function  phonenumbervalidation(val) {
      var phonenumber = val;
      var regPhoneNumber = /^\d{10}$/; 
      if (regPhoneNumber.test(phonenumber)){
        document.getElementById('phno').style.display = 'none'; 
      } else {
        document.getElementById('phno').style.display = 'block'; 
      }
    }
    function emailvalidation(val) {
      var mail = val;
      var email = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (email.test(mail)) {
        document.getElementById('ema').style.display = 'none';
      } else {
        document.getElementById('ema').style.display = 'block';
      }
    }
    function passwordcheck() {
      var pass = document.getElementById('pass').value;
      var cpass = document.getElementById('cpass').value;
      if (pass.length < 8 || pass.length >18) {
        document.getElementById('pl').style.display = 'block';
      } else {
        document.getElementById('pl').style.display = 'none';
      }
    }
    function passwordvalid() {
      var pass = document.getElementById('pass').value;
      var cpass = document.getElementById('cpass').value;
      if (pass == cpass) {
        document.getElementById('pm').style.display = 'none';
      } else {
        document.getElementById('pm').style.display = 'block';
      }
    }
    
  return (
    <>
      <Navbar />
      <div className="containerdet">

        <div className="form-containerdet">
          <center>
          <h5 id="pf" style={{color:'red',display:'none'}}>Please Fill Out the form details..</h5>
          </center>
        
          <form className="needs-validation px-1" onSubmit={handleSubmit} id="myform">
            <div className="form-group">
              <label>Company Name</label>
              <input type="text" placeholder="Enter company name" value={companyname} onChange={(e) =>setCompanyname(e.target.value)}  />
            </div>
            <div className="form-group">
              <label>Mobile</label>
              <div className="mobile-input">
                <span>+91</span>
                <input type="text" placeholder="Enter mobile number" value={mobile} onChange={(e) =>setMobile(e.target.value)} id="mobile" onInput={(e) =>phonenumbervalidation(e.target.value)}  />
              </div>
              <h5 style={{color:'red',display:'none'}} id="phno">Phone Number is not valid!!!</h5>
            </div>
            <div className="form-group">
              <label>Company Email</label>
              <input type="text" placeholder="Enter Email" value={email} onChange={(e) =>setEmail(e.target.value)} onInput={(e) =>emailvalidation(e.target.value)}  />
              <h5 style={{color:'red',display:'none'}} id="ema">Email is not valid!!!</h5>
            </div>
            <div className="form-group">
              <label>Address</label>
              <input type="text" placeholder="Enter address" value={address} onChange={(e) =>setAddress(e.target.value)}  />
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label>Password</label>
                <input type="password" placeholder="Password" id="pass" value={password} onChange={(e) =>setPassword(e.target.value)} onInput={passwordcheck}  />
                <h5 style={{color:'red',display:'none'}} id="pm">Password doesn't match!!!</h5>
              </div>
              <div className="form-group">
                <label>Company Password</label>
                <input type="password" placeholder="Confirm Password" id="cpass" value={cpassword} onChange={(e) =>setCPassword(e.target.value)} onInput={passwordvalid} />
                <h5 style={{color:'red',display:'none'}} id="pl">Password pattern invalid!!!</h5>
              </div>
            </div>
            <div className="form-button">
            <input type="submit" className="submit-btn" value="Continue →"/>
            </div>
          </form>
        </div>
        <div className="logo-container">
          <h3>Add your Company Logo</h3>
          <label className="file-upload">
            <input type="file" onChange={(e) => setImage(e.target.files[0])} accept="image/*" />
            <div className="upload-box">
              <img
                src="https://via.placeholder.com/150"
                alt="Placeholder"
                className="placeholder"
              />
              <span>Choose File</span>
            </div>
          </label>
        </div>
      </div>
    </>
  );
}

export default CompanyRegistration;
